import { ActionIcon, useComputedColorScheme } from "@mantine/core";
import EastRounded from "@mui/icons-material/EastRounded";
import WestRounded from "@mui/icons-material/WestRounded";
import { RefObject } from "react";
import classes from "./TabScrollIcon.module.css";

export default function TabScrollIcon({
  scrollRef,
  dir,
}: {
  scrollRef: RefObject<HTMLDivElement>;
  dir: "left" | "right";
}) {
  const colorScheme = useComputedColorScheme("light");
  function handleScroll() {
    const scrollAreaElement = scrollRef.current;
    if (scrollAreaElement) {
      const scrollWidth = scrollAreaElement.scrollWidth;
      const currentScroll = scrollAreaElement?.scrollLeft;
      const buttonNumber =
        scrollAreaElement.querySelector(".resource-tabs")!.childNodes.length -
        2;
      const scrollAmmount = (scrollAreaElement.scrollWidth / buttonNumber) * 3;
      const scrollPosition = () => {
        function cleansePos(pos: number) {
          return pos < 0 ? 0 : pos > scrollWidth ? scrollWidth : pos;
        }
        const newPos =
          dir === "left"
            ? cleansePos(currentScroll - scrollAmmount)
            : cleansePos(currentScroll + scrollAmmount);
        return newPos;
      };
      scrollAreaElement.scrollTo({
        left: scrollPosition(),
        behavior: "smooth",
      });
    }
  }
  return (
    <ActionIcon
      title={`Scroll ${dir}`}
      color={"darkblue"}
      variant="filled"
      className={classes.scrollIcon}
      onClick={() => handleScroll()}
    >
      {dir === "left" ? <WestRounded /> : <EastRounded />}
    </ActionIcon>
  );
}
